const lockKey = Symbol.for('dapr.notice.scroll-lock');
type LockDocument = Document & { [lockKey]?: { count: number; overflow: string } };
export function lockNoticeScroll(): () => void {
  const owner = document as LockDocument;
  const state = owner[lockKey] ??= { count: 0, overflow: document.body.style.overflow };
  state.count += 1;
  document.body.style.overflow = 'hidden';
  return () => {
    state.count -= 1;
    if (state.count === 0) {
      document.body.style.overflow = state.overflow;
      delete owner[lockKey];
    }
  };
}
export function noticeFocusable(panel: HTMLElement): HTMLElement[] {
  return Array.from(panel.querySelectorAll<HTMLElement>('button, [href], input, select, textarea, [tabindex]'))
    .filter(element => !element.matches(':disabled, [tabindex="-1"]') && !element.closest('[hidden], [inert]')
      && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
}
export function isTopNotice(panel: HTMLElement): boolean {
  const panels = document.querySelectorAll('[data-notice-panel]');
  return panels[panels.length - 1] === panel;
}
export function trapNoticeTab(event: KeyboardEvent, panel: HTMLElement): void {
  const elements = noticeFocusable(panel);
  const first = elements[0];
  const last = elements[elements.length - 1];
  if (!first) { event.preventDefault(); panel.focus(); return; }
  if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
    event.preventDefault(); last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
    event.preventDefault(); first.focus();
  }
}
